import { render, staticRenderFns } from "./banner_index.vue?vue&type=template&id=5bcfb330&scoped=true&"
import script from "./banner_index.vue?vue&type=script&lang=js&"
export * from "./banner_index.vue?vue&type=script&lang=js&"
import style0 from "./banner_index.vue?vue&type=style&index=0&id=5bcfb330&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcfb330",
  null
  
)

export default component.exports